// extracted by mini-css-extract-plugin
export default {"unitsChooser":"UnitsChooser_unitsChooser__cq8R6"};